(module => {
    "use strict";

    module.component('brandSelection', {
        template: require('./brandSelection.html'),
        bindings: {
            parameters: "<",
            market: "<",
            brands: "=",
            selectedBrand:"="
        },
        controller: ['$scope', function(this: $TSFixMe, $scope: $TSFixMe) {
            var $ctrl = this;
        }]
    });

})(angular.module('topline.modules'));